import React, {memo} from 'react';
import {useParams} from 'react-router-dom';

import {useAdminAccessRight} from 'src/hooks/access-rights';

import {Group} from '@pb/kit-component-group';
import Typography from '@pb/kit-component-typography';

import {ChangesInfo} from '../../../../components/changes-info';
import {IpRanges} from '../components/ip-ranges';
import {useRanges} from '../hooks';


export const IPRangesSection = memo<Record<never, void>>(function IPRangesSection() {
    const params = useParams<{accountId: string}>();
    const accountId = params.accountId ? +params.accountId : -1;

    const {ranges, busy, onUpdateRanges} = useRanges();
    const {canEditApiV2} = useAdminAccessRight();

    return (
        <Group direction="v" gap="xl" alignItems="start">
            <Typography
                fontWeight="semi-bold"
                variant="heading-level-3">
                IP Range
            </Typography>
            <Group direction="v" alignItems="start">
                <IpRanges
                    {...{
                        data: ranges?.ipRanges || null,
                        rangesBusy: busy,
                        onUpdateRanges,
                        disabled: !canEditApiV2(accountId),
                    }}
                />
                <ChangesInfo data={ranges?.changesInfo}/>
            </Group>
        </Group>
    );
});
